import React from 'react';
import './TransitionWave.css';

const TransitionWave = () => {
  return (
    <div className="transition-wave">
      <img 
        src="/assets/wave-courbe.png" 
        alt="" 
        className="transition-wave-image"
      />
    </div>
  );
};

export default TransitionWave;

